export default "__VITE_ASSET__Q2a1JfT7__"